import { arrayOf, string, shape, bool, number, instanceOf, func, oneOfType, any } from 'prop-types';

export const formOptionType = shape({
  form_ov: bool,
  label: string,
  value: string
});

export const formsOptionsType = arrayOf(formOptionType);

export const officeType = shape({
  id: number,
  location: string,
  address: string,
  date: string,
  time: string
});

export const officesType = arrayOf(officeType);

export const officeAvailabilityDaysType = arrayOf(
  shape({
    id: string,
    day: string,
    available: bool
  })
);

export const officeSlotType = arrayOf(
  shape({
    id: string,
    working_day_id: string,
    begins_at: instanceOf(Date),
    ends_at: instanceOf(Date),
    available: bool,
    total_turns: string
  })
);

export const referenceType = oneOfType([func, shape({ current: any })]);
